<div class="card shadow-sm h-100" *ngIf="!integracaoKeeta.nova && !integracaoKeeta.editar">
  <div class="card-body">
    <div class="text-center" [hidden]="integracaoKeeta.editar">



      <!-- Informações da Loja -->
      <div class="store-info mb-3">
        <img src="https://img-ap-hongkong.mykeeta.net/sailorfempcpublic/keeta_icon.png"
             height="60px"
             class="mb-2">
        <h6 class="text-primary mb-1">
          <i class="fas fa-store mr-1"></i>
          {{integracaoKeeta.nomeLoja}}
        </h6>
        <p class="text-muted mb-0 small">
          <i class="fas fa-key mr-1"></i>
          ID: <strong>{{integracaoKeeta.idLoja}}</strong>
        </p>

        <!-- Status da Loja Keeta -->
        <div class="store-info mt-2">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <small class="text-muted d-block">Loja no Keeta: </small>
              <strong>
                <span class="text-success" *ngIf="statusKeeta() === this.AVAILABLE">
                  <i class="k-icon k-i-check mr-1"></i>Aberta</span>
                <span class="text-danger" *ngIf="statusKeeta() === this.UNAVAILABLE">
                  <i class="k-icon k-i-pause mr-1"></i>Fechada</span>
                <span class="text-muted" *ngIf="!statusKeeta()">
                   <i class="k-icon k-i-loading  mr-1"  ></i>
                </span>
              </strong>
            </div>
            <div [hidden]="!statusKeeta()">
              <button class="btn btn-success btn-sm" type="button" (click)="abrirLojaKeeta()"
                      [disabled]="ativando" [hidden]="statusKeeta() === this.AVAILABLE">
                <i class="fas fa-power-off  mr-1" [hidden]="ativando"></i>
                <i class="k-icon k-i-loading  mr-1" [hidden]="!ativando"></i>
                Abrir a loja
              </button>
              <button class="btn btn-danger btn-sm ml-2" type="button" (click)="fecharLojaKeeta()"
                      [disabled]="ativando" [hidden]="statusKeeta() === this.UNAVAILABLE">
                <i class="fas fa-power-off mr-1" [hidden]="ativando"></i>
                <i class="k-icon k-i-loading  mr-1" [hidden]="!ativando"></i>
                Fechar a loja
              </button>
            </div>
          </div>
        </div>

      </div>


      <!-- Informações de Data -->
      <ng-container *ngIf="!integracaoKeeta.desativado">
        <div class="date-info mb-3">
          <!-- Status Badge -->
          <div class="mb-2">
          <span class="badge badge-success" *ngIf="!integracaoKeeta.desativado">
            <i class="k-icon k-i-check mr-1"></i>
            Ativo
          </span>
            <span class="badge badge-danger" *ngIf="integracaoKeeta.desativado">
            <i class="k-icon k-i-close mr-1"></i>
            Desativado
          </span>
          </div>

          <div class="row text-center">
            <div class="col-6">
              <small class="text-muted d-block">Ativada em</small>
              <strong class="text-success">{{integracaoKeeta.dataAtivacao | date: 'dd/MM/yyyy'}}</strong>
            </div>
            <div class="col-6">
              <small class="text-muted d-block">Token válido até</small>
              <strong class="text-info">{{integracaoKeeta.validadeToken | date: 'dd/MM/yy HH:mm'}}</strong>
            </div>
          </div>
        </div>


      </ng-container>

      <!-- Botão de Ativação para integrações desativadas -->
      <ng-container *ngIf="integracaoKeeta.desativado">
        <div class="mb-3">
          <button class="btn btn-success btn-block" (click)="ativeIntegracao()" [disabled]="ativando">
            <i class="k-icon k-i-check mr-1"></i>
            Reativar Integração
          </button>
        </div>
      </ng-container>

      <!-- Botões de Ação para integrações ativas -->
      <ng-container *ngIf="!integracaoKeeta.desativado">
        <div class="action-buttons" [hidden]="confirmarDesativar || confirmarRemover">
          <!-- status da loja (via monitoradorPedidos.lojasKeeta na tela principal) será exibido no topo. Aqui oferecemos ação abrir/fechar -->
          <div class="btn-group-vertical w-100 mb-2" role="group">
            <button class="btn btn-success btn-sm mb-1" type="button" (click)="abrirLojaKeeta()" [disabled]="ativando" *ngIf="integracaoKeeta.status === 'UNAVAILABLE'">
              <i class="k-icon k-i-check mr-1"></i>
              Abrir loja no Keeta
            </button>
            <button class="btn btn-warning btn-sm mb-1" type="button" (click)="fecharLojaKeeta()" [disabled]="ativando" *ngIf="integracaoKeeta.status === 'AVAILABLE'">
              <i class="k-icon k-i-pause mr-1"></i>
              Fechar loja no Keeta
            </button>
          </div>
          <div class="btn-group-vertical w-100" role="group">
           <!-- <button class="btn btn-outline-primary btn-sm mb-1" (click)="editarIntegracao(integracaoKeeta)">
              <i class="k-icon k-i-edit mr-1"></i>
              Editar
            </button> -->

           <!--  <button class="btn btn-outline-warning btn-sm mb-1" (click)="confirmeDesativar()">
              <i class="k-icon k-i-pause mr-1"></i>
              Desativar
            </button> -->

            <button class="btn btn-outline-danger btn-sm" (click)="confirmeRemover()">
              <i class="k-icon k-i-delete mr-1"></i>
              Remover Integração
            </button>
          </div>
        </div>

        <!-- Confirmação de Remoção -->
        <div class="confirmation-section" *ngIf="confirmarRemover">
          <div class="alert alert-warning">
            <h6 class="alert-heading">
              <i class="k-icon k-i-warning mr-2"></i>
              Confirmar Remoção
            </h6>
            <p class="mb-2">Tem certeza que deseja remover esta integração?</p>
            <p class="mb-3 small text-muted">Esta ação não pode ser desfeita.</p>
            <div class="d-flex justify-content-end">
              <button class="btn btn-danger btn-sm mr-2" (click)="removerIntegracao()" [disabled]="removendo">
                <i class="k-icon k-i-delete mr-1"></i>
                Sim, Remover
              </button>
              <button class="btn btn-outline-secondary btn-sm" (click)="canceleRemover()">
                Cancelar
              </button>
            </div>
          </div>
        </div>

        <!-- Confirmação de Desativação -->
        <div class="confirmation-section" *ngIf="confirmarDesativar">
          <div class="alert alert-warning">
            <h6 class="alert-heading">
              <i class="k-icon k-i-pause mr-2"></i>
              Confirmar Desativação
            </h6>
            <p class="mb-2">Tem certeza que deseja desativar esta integração?</p>
            <p class="mb-3 small text-muted">Você poderá reativá-la posteriormente.</p>
            <div class="d-flex justify-content-end">
              <button class="btn btn-warning btn-sm mr-2" (click)="desativarIntegracao()" [disabled]="removendo">
                <i class="k-icon k-i-pause mr-1"></i>
                Sim, Desativar
              </button>
              <button class="btn btn-outline-secondary btn-sm" (click)="canceleRemover()">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </ng-container>



    </div>
  </div>
</div>


<div class="card shadow-sm" *ngIf="integracaoKeeta.nova || integracaoKeeta.editar">
  <div class="card-header bg-primary ">
    <h5 class="mb-0 text-black">
      <i class="k-icon k-i-link mr-2"></i>
      Integração com pedidos do <b>Keeta</b>
    </h5>
  </div>

  <div class="card-body">
    <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
          novalidate #frm="ngForm" (ngSubmit)="onSubmit()">

      <ng-container *ngIf="integracaoKeeta.nova">

        <ng-container *ngIf="!integracaoKeeta.authId">
          <!-- Seção 1: Autorização via Link -->
          <div class="integration-section mb-4">
            <div class="section-header mb-3">
              <h6 class="text-primary mb-1">
                <i class="k-icon k-i-globe mr-2"></i>
                Método 1: Autorização via Link
              </h6>
              <p class="text-muted mb-0 small">
                Gere um link de autorização que será aberto em uma nova aba. Após autorizar no Keeta, você será redirecionado de volta para completar a integração.
              </p>
            </div>

            <div class="row">
              <div class="col-12 col-md-6">
                <button class="btn  btn-success btn-lg w-100"
                        type="button"
                        (click)="gereLinkAutorizacao()"
                        [disabled]="gerandoLink || integracaoKeeta.id || ativando">
                  <i class="k-icon k-i-loading mr-2" *ngIf="gerandoLink"></i>
                  <i class="k-icon k-i-globe mr-2" *ngIf="!gerandoLink"></i>
                  Autorizar Loja
                </button>
              </div>
              <div class="col-12 col-md-6 d-flex align-items-center">
                <div class="text-muted small">
                  <i class="k-icon k-i-info mr-1"></i>
                  O link será aberto automaticamente e você será redirecionado de volta após a autorização
                </div>
              </div>
            </div>
          </div>

          <!-- Divisor -->
          <div class="divider-with-text mb-4">
            <span class="text-muted">ou</span>
          </div>

          <!-- Seção 2: Autorização Manual -->
          <div class="integration-section">
            <div class="section-header mb-3">
              <h6 class="text-success mb-1">
                <i class="fas fa-key mr-2"></i>
                Método 2: Autorização Manual
              </h6>
              <p class="text-muted mb-0 small">
                Acesse o Keeta, autorize nosso aplicativo e depois digite o ID da sua loja para completar a integração
              </p>
            </div>

            <!-- Passo 1: Exibir App ID -->
            <div class="app-id-section mb-4">
              <div class="alert alert-info">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 class="alert-heading mb-1">
                      <i class="k-icon k-i-info mr-2"></i>
                      Passo 1: Nosso ID do Aplicativo
                    </h6>
                    <p class="mb-0 small">
                      Copie o ID abaixo para autorizar nosso aplicativo no Keeta
                    </p>
                  </div>
                  <button class="btn btn-outline-primary btn-sm"
                          (click)="copiarAppId()"
                          [disabled]="!appInfo.id">
                    <i class="k-icon k-i-copy mr-1"></i>
                    Copiar ID
                  </button>
                </div>
              </div>

              <div class="app-id-display">
                <div class="input-group">
                  <div class="input-group-prepend">
                  <span class="input-group-text bg-success text-white">
                    <i class="k-icon k-i-key"></i>
                  </span>
                  </div>
                  <input type="text"
                         class="form-control font-weight-bold"
                         [value]="appInfo.id || 'Carregando...'"
                         readonly
                         style="background-color: #f8f9fa; font-family: 'Courier New', monospace;">
                </div>
              </div>
            </div>

            <!-- Passo 2: Instruções -->
            <div class="instructions-section mb-4">
              <div class="alert alert-warning">
                <h6 class="alert-heading mb-2">
                  <i class="k-icon k-i-globe mr-2"></i>
                  Passo 2: Autorizar no Keeta
                </h6>
                <ol class="mb-0 small">
                  <li>Acesse sua Loja portal <a href="https://merchant.mykeeta.com/" target="_blank"><strong>Keeta</strong></a></li>
                  <li>Vá para a aba <a href="https://merchant.mykeeta.com/m/web/openapi/authorize#/app-activation" target="_blank">
                    <strong>"Ativação do aplicativo"</strong>
                  </a>
                   </li>
                  <li>Autorize nosso aplicativo usando o ID copiado acima</li>
                  <li>Após autorizar, copie o <strong>ID da sua loja</strong> no Keeta</li>
                  <li>Cole o ID da loja no campo abaixo e clique em "Completar Integração"</li>
                </ol>
              </div>
            </div>

            <!-- Passo 3: Campo para ID da Loja -->
            <div class="loja-id-section">
              <div class="row">
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label class="form-label">
                      <i class="k-icon k-i-shop mr-1"></i>
                      Passo 3: ID da sua Loja no Keeta
                    </label>
                    <kendo-textbox
                      name="idLoja"
                      placeholder="Cole aqui o ID da sua loja copiado do Keeta"
                      class="form-control"
                      #idLoja="ngModel"
                      [(ngModel)]="idLojaManual"
                      [style.border-left]="'4px solid #28a745'">
                    </kendo-textbox>
                    <div class="invalid-feedback">
                      <p *ngIf="idLoja.errors?.required">Obrigatório</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-7 d-flex align-items-start">
                  <button class="btn btn-success btn-lg w-100 mt-2"
                          type="button"
                          [disabled]="ativando || !idLojaManual"
                          (click)="ativeManualmenteLoja()">
                    <i class="k-icon k-i-loading mr-2" *ngIf="ativando"></i>
                    <i class="k-icon k-i-check mr-2" *ngIf="!ativando"></i>
                    Completar Integração
                  </button>
                </div>
              </div>
            </div>
          </div>

        </ng-container>
        <!-- Seção 3: retorno da sessao 1 -->
        <ng-container *ngIf="integracaoKeeta.authId">
          <div class="integration-section mb-4">
            <div class="section-header mb-3">
              <h6 class="text-success mb-1">
                <i class="k-icon k-i-check mr-2"></i>
                Passo 1 Concluído: Autorização Realizada
              </h6>
              <p class="text-muted mb-0 small">
                Sua autorização foi realizada com sucesso! Agora selecione qual loja deseja integrar.
              </p>
            </div>

            <!-- Seleção de Loja -->
            <div class="loja-selection-section mb-4">
              <div class="alert alert-success">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 class="alert-heading mb-1">
                      <i class="k-icon k-i-shop mr-2"></i>
                      Passo 2: Selecionar Loja para Integração
                    </h6>
                    <p class="mb-0 small">
                      Escolha qual loja do Keeta você deseja integrar com o MeuCardápio
                    </p>
                  </div>
                </div>
              </div>

              <div class="loja-dropdown">
                <div class="form-group">
                  <label class="form-label">
                    <i class="k-icon k-i-shop mr-1"></i>
                    Selecione a Loja
                  </label>
                  <kendo-dropdownlist
                    name="lojaSelecionada"
                    class="form-control"
                    #lojaSelecionada="ngModel"
                    [(ngModel)]="integracaoKeeta.lojaSelecionada"
                    [data]="integracaoKeeta.lojasAtivar"
                    textField="name"
                    valueField="id"
                    [style.border-left]="'4px solid #28a745'">
                  </kendo-dropdownlist>
                  <div class="invalid-feedback">
                    <p *ngIf="lojaSelecionada.errors?.required">Obrigatório</p>
                  </div>
                </div>
              </div>

              <!-- Informações da Loja Selecionada -->
              <div class="loja-info" *ngIf="integracaoKeeta.lojaSelecionada">
                <div class="card border-success">
                  <div class="card-body">
                    <h6 class="card-title text-success">
                      <i class="k-icon k-i-shop mr-2"></i>
                      {{integracaoKeeta.lojaSelecionada.name}}
                    </h6>
                    <div class="row">
                      <div class="col-md-6">
                        <small class="text-muted d-block">ID da Loja</small>
                        <strong>{{integracaoKeeta.lojaSelecionada.id}}</strong>
                      </div>
                      <div class="col-md-6">
                        <small class="text-muted d-block">Endereço</small>
                        <strong>{{integracaoKeeta.lojaSelecionada.address}}</strong>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <small class="text-muted d-block">Fuso Horário</small>
                        <strong>{{integracaoKeeta.lojaSelecionada.timeZone}}</strong>
                      </div>
                      <div class="col-md-6">
                        <small class="text-muted d-block">Coordenadas</small>
                        <strong>{{integracaoKeeta.lojaSelecionada.latitude}}, {{integracaoKeeta.lojaSelecionada.longitude}}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Botão de Autorização -->
              <div class="authorization-section mt-4">
                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-success btn-lg w-100"
                            type="button"
                            [disabled]="ativando || !integracaoKeeta.lojaSelecionada"
                            (click)="ativeLojaSelecionada()">
                      <i class="k-icon k-i-loading mr-2" *ngIf="ativando"></i>
                      <i class="k-icon k-i-check mr-2" *ngIf="!ativando"></i>
                      Autorizar Loja Selecionada
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>


        <!-- Mensagens de erro -->
        <div class="row mt-3">
          <div class="col-12">
            <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
              <i class="k-icon k-i-warning mr-2"></i>
              {{mensagemErro}}
              <button type="button" class="close" aria-label="Close" (click)="fecharAlerta()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
            </div>

        <!-- Botões de ação -->
        <div class="row mt-4">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <button class="btn btn-outline-secondary"
                      type="button"
                      (click)="integracaoKeeta.editar = false"
                      [hidden]="!integracaoKeeta.id">
                <i class="k-icon k-i-arrow-left mr-1"></i>
              Voltar
            </button>

              <div class="text-muted small d-flex align-items-center">
                <i class="k-icon k-i-info mr-1"></i>
                Escolha um dos métodos acima para continuar
              </div>
            </div>
          </div>
        </div>

      </ng-container>

    </form>
  </div>
</div>
